import Vue from "vue";
import $bizConfig from "@/models/bizConfig.js";
import $web3js from "../web3.js";
import $erc20 from "../erc20/index.js";
import $utils from "@/lib/utils/index.js";

const dmcPoolContract = require("./dmcPoolContract.json");

let web3 = $web3js.getWeb3();
let contractAddress = $bizConfig.dmcPoolContractAddress;
let contractConst = {
  contract: web3 ? new web3.eth.Contract(dmcPoolContract.abi, contractAddress) : ""
};

const getDmcPoolAddress = () => {
  return contractAddress;
};

const getDmcPoolContract = () => {
  return contractConst.contract;
};

const dmcPoolUserDeposit = async ([_pid, _amount, _contractAddress], options, callback) => {
  _pid = $web3js.stringToBytes32(_pid);
  _amount = await $erc20.toErc20Value(_amount, _contractAddress);
  return $web3js.send(getDmcPoolContract().methods.userDeposit, [_pid, _amount], options, callback);
};

const dmcPoolUserDepositEstimateSend = async ([_pid, _amount, _contractAddress], options) => {
  _pid = $web3js.stringToBytes32(_pid);
  _amount = await $erc20.toErc20Value(_amount, _contractAddress);
  
  let gasPromise = $web3js.estimateSend(getDmcPoolContract().methods.userDeposit, [_pid, _amount], options);
  let gasPricePromise = $web3js.getGasPrice();

  let [e1, gas] = await $utils.awaitWrap(gasPromise);
  let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
  if (!!e1) {
    Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
    return null;
  }

  let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
  return { gas, gasPrice, fee };
}

const dmcPoolUserRedeem = async ([_pid, _amount, _contractAddress], options, callback) => {
  _pid = $web3js.stringToBytes32(_pid);
  _amount = await $erc20.toErc20Value(_amount, _contractAddress);

  let dmcMiningContractAddress = $bizConfig.dmcMiningContractAddress;
  if (!!dmcMiningContractAddress) {
    return $web3js.send(getDmcPoolContract().methods.userRedeemV2, [dmcMiningContractAddress, _pid, _amount], options, callback);
  }
  return $web3js.send(getDmcPoolContract().methods.userRedeem, [_pid, _amount], options, callback);
};

const dmcPoolUserRedeemEstimateSend = async ([_pid, _amount, _contractAddress], options) => {
  _pid = $web3js.stringToBytes32(_pid);
  _amount = await $erc20.toErc20Value(_amount, _contractAddress);
  let dmcMiningContractAddress = $bizConfig.dmcMiningContractAddress;

  let gasPromise;
  if (!!dmcMiningContractAddress) {
    gasPromise = $web3js.estimateSend(getDmcPoolContract().methods.userRedeemV2, [dmcMiningContractAddress, _pid, _amount], options);
  } else {
    gasPromise = $web3js.estimateSend(getDmcPoolContract().methods.userRedeem, [_pid, _amount], options);
  }
  let gasPricePromise = $web3js.getGasPrice();

  let [e1, gas] = await $utils.awaitWrap(gasPromise);
  let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
  if (!!e1) {
    Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
    return null;
  }

  let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
  return { gas, gasPrice, fee };
}

const dmcPoolUserIncome = ([_pid], options, callback) => {
  _pid = $web3js.stringToBytes32(_pid);
  return $web3js.send(getDmcPoolContract().methods.userIncome, [_pid], options, callback);
};

const dmcPoolUserIncomeEstimateSend = async ([_pid], options) => {
  _pid = $web3js.stringToBytes32(_pid);

  let gasPromise = $web3js.estimateSend(getDmcPoolContract().methods.userIncome, [_pid], options);
  let gasPricePromise = $web3js.getGasPrice();

  let [e1, gas] = await $utils.awaitWrap(gasPromise);
  let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
  if (!!e1) {
    Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
    return null;
  }

  let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
  return { gas, gasPrice, fee };
}

const dmcPoolVendorWithdraw = ([_pid], options, callback) => {
  _pid = $web3js.stringToBytes32(_pid);
  return $web3js.send(getDmcPoolContract().methods.vendorWithdraw, [_pid], options, callback);
};

const dmcPoolVendorWithdrawEstimateSend = async ([_pid], options) => {
  _pid = $web3js.stringToBytes32(_pid);
  let gasPromise = $web3js.estimateSend(
    getDmcPoolContract().methods.vendorWithdraw,
    [_pid], options
  );
  let gasPricePromise = $web3js.getGasPrice();

  let [e1, gas] = await $utils.awaitWrap(gasPromise);
  let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
  if (!!e1) {
    Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
    return null;
  }

  let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
  return { gas, gasPrice, fee };
}

const getDmcPoolInfo = ([_pid, ptoken, dli], options) => {
  _pid = $web3js.stringToBytes32(_pid);
  return $web3js.call(getDmcPoolContract().methods.getMiningPoolInfo, [_pid], options, handlePoolInfo, [ptoken, dli]);
};

const handlePoolInfo = async (res, ptoken, dli) => {
  // console.log(res)
  let index = 0;
  let totalPrincipalAmount = res[index++];
  let totalBenefitAmount = res[index++];
  let principalLiquidAmount = res[index++];
  let benefitLiquidAmount = res[index++];
  let principalExchangeAmount = res[index++];
  let benefitExchangeAmount = res[index++];
  let dpPrice = res[index++];

  totalPrincipalAmount = await $erc20.fromErc20Value(totalPrincipalAmount, ptoken);
  totalBenefitAmount = await $erc20.fromErc20Value(totalBenefitAmount, dli);
  principalLiquidAmount = await $erc20.fromErc20Value(principalLiquidAmount, ptoken);
  benefitLiquidAmount = await $erc20.fromErc20Value(benefitLiquidAmount, dli);
  principalExchangeAmount = await $erc20.fromErc20Value(principalExchangeAmount, ptoken);
  benefitExchangeAmount = await $erc20.fromErc20Value(benefitExchangeAmount, dli);
  dpPrice = Vue.prototype.$numberUtils.movePointLeft(dpPrice, 18);

  return {
    totalPrincipalAmount,
    totalBenefitAmount,
    principalLiquidAmount,
    benefitLiquidAmount,
    principalExchangeAmount,
    benefitExchangeAmount,
    dpPrice
  };
};

const getDmcPoolUserDliInfo = ([_pid, _user, dli], options) => {
  _pid = $web3js.stringToBytes32(_pid);
  return $web3js.call(getDmcPoolContract().methods.getUserDliInfo, [_pid, _user], options, handleDliInfo, [dli]);
};

const handleDliInfo = async (res, dli) => {
  // console.log(res)
  let index = 0;
  let totalDliAmount = res[index++];
  let totalDliLockAmount = res[index++];

  totalDliAmount = await $erc20.fromErc20Value(totalDliAmount, dli);
  totalDliLockAmount = await $erc20.fromErc20Value(totalDliLockAmount, dli);

  return {
    totalDliAmount,
    totalDliLockAmount
  };
};

const getDmcPoolGlobalInfo = ([_pid], options) => {
  return $web3js.call(
    getDmcPoolContract().methods.getGlobalInfo,
    [_pid], options,
    handlePoolGlobalInfo
  );
};

const handlePoolGlobalInfo = async (res) => {
  // console.log(res)
  let index = 0;
  let ptoken = res[index++];
  let afil = res[index++];
  let dlp = res[index++];
  let dli = res[index++];
  let dpPrice = res[index++];
  let userDeposits = res[index++];
  let userGainPrincipals = res[index++];
  let userGainBenefits = res[index++];
  let plateformBenefits = res[index++];
  let vendorGains = res[index++];
  let vendorReleasePrincipals = res[index++];
  let vendorReleaseBenefits = res[index++];
  let state = res[index++];
  let active = res[index++];

  userDeposits = await $erc20.fromErc20Value(userDeposits, ptoken);
  userGainPrincipals = await $erc20.fromErc20Value(userGainPrincipals, ptoken);
  userGainBenefits = await $erc20.fromErc20Value(userGainBenefits, dli);
  plateformBenefits = await $erc20.fromErc20Value(plateformBenefits, dli);
  vendorGains = await $erc20.fromErc20Value(vendorGains, ptoken);
  vendorReleasePrincipals = await $erc20.fromErc20Value(vendorReleasePrincipals, ptoken);
  vendorReleaseBenefits = await $erc20.fromErc20Value(vendorReleaseBenefits, dli);
  dpPrice = Vue.prototype.$numberUtils.movePointLeft(dpPrice, 18);

  return {
    ptoken,
    afil,
    dlp,
    dli,
    dpPrice,
    userDeposits,
    userGainPrincipals,
    userGainBenefits,
    plateformBenefits,
    vendorGains,
    vendorReleasePrincipals,
    vendorReleaseBenefits,
    state,
    active
  };
};

const getDmcPoolUserIncome = ([_pid], options) => {
  return $web3js.call(getDmcPoolContract().methods.getUserIncome, [_pid], options, $web3js.fromWei);
};

const handleUserIncome = async (res) => {
  let index = 0;
  let incomeBalance = await $web3js.fromWei(res[index++]);
  let lockedIncomeBalance = await $web3js.fromWei(res[index++]);
  return {
    incomeBalance,
    lockedIncomeBalance
  }
}

export default {
  getDmcPoolAddress,
  getDmcPoolContract,
  dmcPoolUserDeposit,
  dmcPoolUserDepositEstimateSend,
  dmcPoolUserRedeem,
  dmcPoolUserRedeemEstimateSend,
  dmcPoolUserIncome,
  dmcPoolUserIncomeEstimateSend,
  dmcPoolVendorWithdraw,
  dmcPoolVendorWithdrawEstimateSend,
  getDmcPoolInfo,
  getDmcPoolGlobalInfo,
  getDmcPoolUserIncome,
  getDmcPoolUserDliInfo
};



// WEBPACK FOOTER //
// ./src/lib/contract/dmcPool/index.js